export default "__VITE_ASSET__DSH1KR0F__"